import _ from "underscore";
import { MillenniumDate } from "@timeedit/millennium-time";

export const getSelectableYears = (
    startDate?: MillenniumDate,
    endDate?: MillenniumDate
): number[] => {
    if (!startDate || !endDate) {
        return [];
    }
    return _.range(startDate.getYear(), endDate.getYear() + 1);
};
